<img
  alt="spinner"
  src="assets/app/img/qs-spinner.svg"
  [width]="size()"
  [height]="size()"
  class="spinner"
/>
